<template>
<div>
    <v-container>
        <v-form :key="sort" ref="form">
            <v-row>
                <span v-if="sort>2" class="centered text-centered display-1 font-weight-light">{{question.question}} (Optional)</span>
                <span v-else class="centered text-centered display-1 font-weight-light">{{question.question}}</span>
            </v-row>
            <v-row justify="center">
                <v-checkbox 
                    v-model="form.consent" 
                    class="mx-2" 
                    :rules="sort > 2 && !form.email ? noRules : [v => !!v || 'We need your consent in order to contact the referee']"
                    label="We are permitted to contact your referees">
                </v-checkbox>
            </v-row>
            <v-row justify="center">
                <v-col class="col-8">
                    <v-combobox
                        v-model="form.relationship"
                        :items="relationships[sort]"
                        @update:search-input="form.relationship = $event"
                        label="Relationship to me"
                        hint="You may type in other relationships too"
                        persistent-hint
                        :rules="sort > 2 ? noRules :notNull"
                        value=""
                        outlined
                    ></v-combobox>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col class="col-3">
                    <v-text-field
                        label="First Name" 
                        v-model="form.first_name"
                        :rules="sort > 2 ? noRules :fullString"
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col class="col-5">
                    <v-text-field
                        label="Last Name"
                        v-model="form.last_name"
                        :rules="sort > 2 ? noRules :fullString"
                        outlined
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col class="col-8">
                    <v-text-field
                        label="Email"
                        v-model="form.email"
                        :rules="sort > 2 ? optionalEmail : validEmail"
                        outlined
                    ></v-text-field>
                </v-col>
            </v-row>

            <v-row v-if="question.helper_text" justify="center">
                <v-col class="col-8">
                    <img src="/help_icon.png" class="bulb-icon" @click="showHelperText = !showHelperText">
                    <span :class="showHelperText ? 'visible help-text' : 'hidden help-text'">{{question.helper_text}}</span>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</div>
</template>
<script>
import axios from 'axios'
import Client from '../client.js'

export default {
    props: {
        stage_key: String,
        sort: [String, Number],
        application_id: [String, Number]
    },
    data: function () {
        return {
            question: {},
            form: {},
            relationships: {
                1: ['Liaison Officer', 'School Teacher', 'Community Elder'],
                2: ['School Principle','Aboriginal Liaison Officers','Staff Member','Staff Coach'],
                3: ['Liaison Officer', 'School Teacher', 'Community Elder']
            },
            showHelperText: true
        }
    },
    mounted() {
        this.fetchData(this.sort);
    },
    watch: {
        'sort': function (sort) {
            this.clearState();
            this.fetchData(sort);
        }
    },
    computed: {
        fullString() {
            return [
                v => v !== null && v !== undefined && v.length > 1
            ]
        },
        notNull() {
            return [
                v => v !== null && v !== undefined
            ]
        },
        validEmail() {

            let rules = [v => !!v || 'Email is required']
            return this.sort == 2 ? [
                    ...rules, 
                    v => /.+@det\.nsw\.edu\.au|.+@schools\.sa\.edu\.au/.test(v.toLowerCase()) || 'Must be a valid school teacher\'s email'
                ] : [
                ...rules, 
                v => /.+@\S+\.\S+/.test(v) || 'Email must be valid' 
            ]
                
        },
        optionalEmail() {
            return[
                v => !v || /.+@\S+\.\S+/.test(v) || 'Email must be valid'
            ]
        },
        noRules() {
            return [() => true]
        }
    },
    methods: {
        async fetchData(sort) {
            let client = Client();
            let ress = await axios.all([
                client.get(`/stages/${this.stage_key}/questions/${sort}`),
            ]);
            this.question = ress[0].data;
            let ress2 = await axios.all([
                client.get(`/applications/${this.application_id}/questions/${this.question.id}`)
            ]);
            if(ress2) {
                const str = ress2[0].data.answer;
                this.form = JSON.parse(str);
            }
        },
        async submit() {
            if(this.sort > 2) {
                return true;
            }
            let client = Client();
            return await client.post(
                `applications/${this.application_id}/questions/${this.question.id}`,
                { answer: JSON.stringify(this.form) }
            )
            .then(() => true)
            .catch(() => false);
        },
        clearState() {
            this.question = {};
            this.form = {};
        }
    }
}
</script>
<style lang="scss" scoped>
.lightbulb-icon {
    color: $go-orange;
    margin-right: 10px;
}

.lightbulb-icon:hover {
    cursor: pointer;
}

.centered {
    margin-left: auto;
    margin-right: auto;
    display: block;
    // width: 70%
}

.text-centered {
    text-align: center;
}

.margin-top {
    margin-top: 10%;
}
</style>